module.exports = __webpack_public_path__ + "img/htp-slide-two.c99ecd88.png";